"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadManager = void 0;
var typescript_collections_1 = require("typescript-collections");
var Application_1 = require("../Application");
var Topics = require("../Data/Topics");
var AssetUtils_1 = require("../Utils/AssetUtils");
var LogUtils = require("../Utils/LogUtils");
var AssetMap_1 = require("./AssetMap");
var AssetMapAudioData_1 = require("./AssetMapAudioData");
var SplashScreen_1 = require("./SplashScreen");
/**
 * Manages all asset loading.
 * @extends PIXI.Container
 */
var LoadManager = /** @class */ (function (_super) {
    __extends(LoadManager, _super);
    /**
     * Creates an instance of a `LoadManager` and returns it.
     * @param pSplashScreen The splashscreen instance to use.
     */
    function LoadManager(pSplashScreen) {
        var _this = _super.call(this) || this;
        /**
         * Is current load screen persistent or created and destroyed on demand
         */
        _this._isCurrentLoadScreenPersistent = true;
        /**
         * The internal flag for print log statements.
         */
        _this._debug = false;
        _this._size = new PIXI.Point();
        _this._loadScreens = new typescript_collections_1.Dictionary();
        _this._currentLoadScreen = pSplashScreen;
        _this._splashScreen = pSplashScreen;
        PubSub.subscribe(Topics.SHOW_LOAD_SCREEN, _this.showLoadScreen.bind(_this));
        PubSub.subscribe(Topics.HIDE_LOAD_SCREEN, _this.hideLoadScreen.bind(_this));
        PubSub.subscribe(Topics.LOAD_ASSETS, _this.onLoadRequested.bind(_this));
        PubSub.subscribe(Topics.UNLOAD_ASSETS, _this.onUnloadRequested.bind(_this));
        PIXI.Loader.shared.onProgress.add(_this.onPixiLoadProgress.bind(_this));
        PIXI.Loader.shared.onError.add(_this.logE.bind(_this));
        return _this;
    }
    Object.defineProperty(LoadManager.prototype, "debug", {
        /**
         * Enabling this will print all debug logs.
         */
        set: function (pEnabled) {
            this._debug = pEnabled;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Updates the current active load screen.
     * @param pDeltaTime PIXI.ticker.shared.elapsedMS / 1000.
     */
    LoadManager.prototype.update = function (pDeltaTime) {
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.update(pDeltaTime);
        }
    };
    /**
     * Begins the initial splash process.
     * @description
     * 1. Splash screen assets loaded.
     * 2. Splash screen is shown.
     * 3. Persistent assets are loaded.
     * 4. Callback passed in is called.
     * @param pPersistentAssets The assets that should persist between all state changes.
     * @param pOnComplete The function to call after all persitent assets have been loaded.
     */
    LoadManager.prototype.startSplashProcess = function (pPersistentAssets, pOnComplete) {
        var _this = this;
        // Remove assets from the persistent list that will already be loaded by the splash screen.
        var splashAssets = AssetMap_1.AssetMap.getAssetGroup(SplashScreen_1.SplashScreen.NAME);
        var trimmedRequiredAssets = new Array();
        for (var i = 0; i < pPersistentAssets.length; i++) {
            var requiredAsset = pPersistentAssets[i];
            var found = false;
            for (var j = 0; j < splashAssets.length; j++) {
                var splashAsset = splashAssets[j];
                if (requiredAsset.assetName === splashAsset.assetName) {
                    if (requiredAsset.assetType === splashAsset.assetType) {
                        found = true;
                        break;
                    }
                }
            }
            if (found === false) {
                trimmedRequiredAssets.push(requiredAsset);
            }
        }
        // Load splash assets
        // On complete, show the splash screen
        this.loadOnSplash(AssetMap_1.AssetMap.getAssetGroup(SplashScreen_1.SplashScreen.NAME), function () {
            // On animate in complete, load required assets
            // On complete, call passed in callback
            _this._splashScreen.init(_this._size);
            _this.addChild(_this._splashScreen);
            _this._splashScreen.animateIn(function () { return _this.load(trimmedRequiredAssets, pOnComplete); });
        });
    };
    /**
     * Registers a load screen.
     * @param pKey The id of the load screen.
     * @param pScreen The load screen.
     * @param [pDefault] Is the new load screen the default one.
     */
    LoadManager.prototype.registerLoadScreen = function (pKey, pScreen, pDefault) {
        if (pDefault === void 0) { pDefault = false; }
        this._loadScreens.setValue(pKey, pScreen);
        if (pDefault) {
            this._defaultLoadScreen = pScreen;
        }
    };
    /**
     * Called when the window is resized.
     * @param pSize The new size.
     */
    LoadManager.prototype.onResize = function (pSize) {
        this._size.copyFrom(pSize);
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.onResize(this._size);
        }
    };
    /**
     * Attempts to show the requested load screen.
     * @param pTopic The PubSub message id.
     * @param pData Data containing what loadscreen to show and what to call when it is shown.
     */
    LoadManager.prototype.showLoadScreen = function (pTopic, pData) {
        var _this = this;
        this.log("Show load screen requested: %c%s", LogUtils.STYLE_RED_BOLD, pData.loadScreen);
        this._currentLoadScreen = this.getLoadScreen(pData.loadScreen);
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.init(this._size, pData.stateData);
            this.addChild(this._currentLoadScreen);
            this._currentLoadScreen.animateIn(function () {
                _this.log("Load screen animate in complete.");
                pData.callback();
            });
        }
        else {
            this.logE("%c%s%c has not been registered as a load screen. Please include it in your registerLoadScreen " +
                "implementation.", LogUtils.STYLE_RED_BOLD, pData.loadScreen, LogUtils.STYLE_BLACK);
        }
    };
    /**
     * Attempts to hide the requested load screen.
     * @param pTopic The PubSub message id.
     * @param pData Data containing what loadscreen to hide and what to call when it is hidden.
     */
    LoadManager.prototype.hideLoadScreen = function (pTopic, pData) {
        var _this = this;
        this.log("Hide load screen requested: %c%s", LogUtils.STYLE_RED_BOLD, pData.loadScreen);
        var data = pData;
        if (this._currentLoadScreen === undefined) {
            this._currentLoadScreen = this.getLoadScreen(pData.loadScreen);
        }
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.animateOut(function () {
                _this.onLoadAnimateOutComplete();
                data.callback();
            });
        }
        else {
            this.logE("%c%s%c has not been registered as a load screen. Please include it in your registerLoadScreen " +
                "implementation.", LogUtils.STYLE_RED_BOLD, pData.loadScreen, LogUtils.STYLE_BLACK);
        }
    };
    /**
     * Loads requested assets using the supplied loadscreen.
     * @param pAssets The assets to load.
     * @param pOnComplete The function to call when the load is complete.
     */
    LoadManager.prototype.load = function (pAssets, pOnComplete) {
        if (this._onLoadComplete !== undefined) {
            this.logW("Replacing existing _onLoadComplete callback!");
        }
        this.log("Asset Load requested. Count: %c%s", LogUtils.STYLE_RED_BOLD, pAssets === undefined ? "Nothing to load" : pAssets.length);
        this._onLoadComplete = pOnComplete;
        this.loadAssets(pAssets);
    };
    /**
     * Loads assets needed by the splash screen.
     * @param pAssets The splash screen assets to load.
     * @param pOnComplete The function to call when assets are loaded.
     */
    LoadManager.prototype.loadOnSplash = function (pAssets, pOnComplete) {
        if (this._onLoadComplete !== undefined) {
            this.logW("Replacing existing _onLoadComplete callback!");
        }
        this.log("Splash Asset Load requested. Count: %c%s", LogUtils.STYLE_RED_BOLD, pAssets === undefined ? "Nothing to load" : pAssets.length);
        this._onLoadComplete = pOnComplete;
        this._currentLoadScreen = this._splashScreen;
        this.loadAssets(pAssets);
    };
    /**
     * Removes assets from PIXI cache.
     * @param pAssets The assets to unload.
     * @param pOnComplete The function to call when the unload is complete.
     */
    LoadManager.prototype.unload = function (pAssets, pOnComplete) {
        if (pAssets !== undefined) {
            for (var _i = 0, pAssets_1 = pAssets; _i < pAssets_1.length; _i++) {
                var asset = pAssets_1[_i];
                this.log("Trying to destroy %c%s", LogUtils.STYLE_RED_BOLD, asset.assetName);
                if (asset instanceof AssetMapAudioData_1.AssetMapAudioData) {
                    this.destroyAudioResource(asset);
                }
                else {
                    this.destroyPixiResource(asset.assetName);
                }
                asset.destroy();
            }
        }
        if (pOnComplete !== undefined) {
            pOnComplete();
        }
    };
    /**
     * Retrieves a load screen.
     * @param pLoadScreen The load screen to retrieve.
     * @returns The requested load screen or undefined.
     */
    LoadManager.prototype.getLoadScreen = function (pLoadScreen) {
        this._isCurrentLoadScreenPersistent = true;
        if (pLoadScreen !== undefined) {
            var loadScreen = this._loadScreens.getValue(pLoadScreen);
            if (typeof loadScreen === "function") {
                this._isCurrentLoadScreenPersistent = false;
                loadScreen = loadScreen();
            }
            if (loadScreen !== undefined) {
                this.log("Loadscreen %c%s%c found", LogUtils.STYLE_RED_BOLD, pLoadScreen, LogUtils.STYLE_BLACK);
                return loadScreen;
            }
            else {
                this.log("Load screen %c%s%c not found", LogUtils.STYLE_RED_BOLD, pLoadScreen, LogUtils.STYLE_BLACK);
                return undefined;
            }
        }
        else {
            this.log("No load screen requested -> Returning the default loadscreen");
            var loadScreen = this._defaultLoadScreen;
            if (typeof loadScreen === "function") {
                this._isCurrentLoadScreenPersistent = false;
                loadScreen = loadScreen();
            }
            return loadScreen;
        }
    };
    /**
     * Loads the requested assets.
     * @todo Relish SH => Find out how to properly handle load screens when assets are already cached.
     * Currently, doesn't animate load bar at all (remains empty) since no loading occurs.
     * Ideally, should animate to full, OR not appear at all.
     * @param pAssets The assets requested.
     */
    LoadManager.prototype.loadAssets = function (pAssets) {
        var _this = this;
        if (pAssets !== undefined) {
            var assets = this.removeRedundantLoads(pAssets);
            var audioAssets_1 = [];
            for (var _i = 0, assets_1 = assets; _i < assets_1.length; _i++) {
                var asset = assets_1[_i];
                if (asset.resolutionSuffix && asset.resolutionSuffix !== AssetUtils_1.AssetUtils.resolutionSuffix) {
                    continue;
                }
                this.log("file requested: %c%s", LogUtils.STYLE_RED_BOLD, asset.assetName);
                if (asset instanceof AssetMapAudioData_1.AssetMapAudioData) {
                    audioAssets_1.push(asset);
                }
                else {
                    PIXI.Loader.shared.add(asset.assetName, asset.assetPath ?
                        AssetUtils_1.AssetUtils.replaceResolutionToken(asset.assetPath) :
                        AssetUtils_1.AssetUtils.getPathToAsset(asset), asset.getLoaderOptions());
                }
            }
            if (audioAssets_1.length > 0) {
                PIXI.Loader.shared.load(function () {
                    _this.log("PIXI load complete");
                    PubSub.publishSync(Topics.LOAD_AUDIO_FROM_ASSET_MAP, {
                        assets: audioAssets_1,
                        callback: function () {
                            _this.log("Audio load complete.");
                            _this.onAllLoadsComplete();
                        },
                        progressCallback: _this.onAudioLoadProgress.bind(_this),
                    });
                });
            }
            else {
                this.log("No AUDIO to load");
                PIXI.Loader.shared.load(this.onAllLoadsComplete.bind(this));
            }
        }
        else {
            this.log("Nothing to load");
            this.onAllLoadsComplete();
        }
    };
    /**
     * Unloads the track and removes it from the AudioManager.
     * @param pData The audio data of thee track to destroy.
     */
    LoadManager.prototype.destroyAudioResource = function (pData) {
        Application_1.Application.instance.audio.unload(pData.assetName, pData.category, true);
    };
    /**
     * Removes assets from PIXI cache and unloads them from webGL.
     * @param pId The id of the asset to destroy.
     */
    LoadManager.prototype.destroyPixiResource = function (pId) {
        var resource = PIXI.Loader.shared.resources[pId];
        if (resource !== undefined) {
            if (resource.children.length > 0) {
                this.log("Destroying resource " + pId + " and its children: ", resource.children.map(function (c) { return c.name; }));
            }
            else {
                this.log("Destroying resource " + pId);
            }
        }
        else {
            this.logE("Can't find resource to destroy: " + pId);
            return;
        }
        var textures = resource.textures;
        if (textures !== undefined) {
            var keys = Object.keys(textures);
            for (var i = 0; i < keys.length; ++i) {
                textures[keys[i]].destroy(false);
            }
        }
        if (resource.texture !== undefined) {
            resource.texture.destroy(true);
        }
        if (resource.spineAtlas !== undefined) {
            resource.spineAtlas.dispose();
        }
        for (var i = 0; i < resource.children.length; ++i) {
            this.destroyPixiResource(resource.children[i].name);
        }
        delete PIXI.Loader.shared.resources[pId];
    };
    /**
     * Removes redundant requested loads.
     * @param pAssets The asset list to search through.
     * @returns The trimmed down asset list.
     */
    LoadManager.prototype.removeRedundantLoads = function (pAssets) {
        var prunedAssets = new Array();
        var curAsset;
        for (var i = 0; i < pAssets.length; ++i) {
            var isFound = false;
            curAsset = pAssets[i];
            for (var j = 0; j < prunedAssets.length; j++) {
                var assetInList = prunedAssets[j];
                if (assetInList.assetName === curAsset.assetName && assetInList.resolutionSuffix === curAsset.resolutionSuffix) {
                    isFound = true;
                    break;
                }
            }
            if (isFound === false) {
                this.log("Adding %c%s%c to the final list.", LogUtils.STYLE_RED_BOLD, curAsset.assetName, LogUtils.STYLE_BLACK);
                prunedAssets.push(curAsset);
            }
            else {
                this.log("Excluding %c%s%c from the final list because it is already included.", LogUtils.STYLE_RED_BOLD, curAsset.assetName, LogUtils.STYLE_BLACK);
            }
        }
        return prunedAssets;
    };
    /**
     * Called when a file is loaded in PIXI.
     * @param pLoader The PIXI loader.
     * @param pResource The resource that was loaded.
     */
    LoadManager.prototype.onPixiLoadProgress = function (pLoader, pResource) {
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.onLoadProgress(pLoader, pResource, 0);
        }
    };
    /**
     * Called when a file is loaded by the {@link IAudioManager} (usually {@link HowlerManager}).
     * @param pLoader The PIXI loader.
     * @param pResource The resource that was loaded.
     */
    LoadManager.prototype.onAudioLoadProgress = function (pProgress) {
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.onLoadProgress({ progress: pProgress }, undefined, 1);
        }
    };
    /**
     * Called once both audio and PIXI have finished loading assets
     */
    LoadManager.prototype.onAllLoadsComplete = function () {
        if (this._currentLoadScreen !== undefined) {
            this._currentLoadScreen.onLoadComplete(this.onLoadScreenComplete.bind(this));
        }
        else {
            this.onLoadScreenComplete();
        }
    };
    /**
     * Called when all assets required for the requested state are loaded.
     */
    LoadManager.prototype.onLoadScreenComplete = function () {
        this.log("Requested load complete.");
        if (this._onLoadComplete !== undefined) {
            var callback = this._onLoadComplete;
            this._onLoadComplete = undefined;
            callback();
            // NOTE: The callback might trigger another load, in which case this._onLoadComplete is no longer undefined!
        }
        else {
            this.logE("_onLoadComplete undefined in onLoadScreenComplete");
        }
    };
    /**
     * Called when the load screen is completely hidden.
     */
    LoadManager.prototype.onLoadAnimateOutComplete = function () {
        this.log("Load screen completely hidden.");
        if (this._currentLoadScreen) {
            this.removeChild(this._currentLoadScreen);
            if (!this._isCurrentLoadScreenPersistent) {
                this._currentLoadScreen.destroy();
            }
        }
        this._currentLoadScreen = undefined;
        PubSub.publishSync(Topics.LOAD_SCREEN_HIDDEN, undefined);
    };
    /**
     * Called when a load is requested.
     * @param pTopic The PubSub message id.
     * @param pToken The data defining the load request.
     */
    LoadManager.prototype.onLoadRequested = function (pTopic, pToken) {
        this.log("Load requested");
        this.load(pToken.assets, pToken.callback);
    };
    /**
     * Called when an unload is requested.
     * @param pTopic The PubSub message id.
     * @param pToken The data defining the unload request.
     */
    LoadManager.prototype.onUnloadRequested = function (pTopic, pToken) {
        this.log("Unload requested");
        this.unload(pToken.assets, pToken.callback);
    };
    /**
     * Logs a message with class name and colour coding if debug flag is true.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    LoadManager.prototype.log = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            LogUtils.log.apply(LogUtils, __spreadArrays([pText, { className: "LoadManager", color: "orange" }], pParams));
        }
    };
    /**
     * Logs a warning message with class name and colour coding if debug flag is true.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    LoadManager.prototype.logW = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            LogUtils.logWarning.apply(LogUtils, __spreadArrays([pText, { className: "LoadManager", color: "orange" }], pParams));
        }
    };
    /**
     * Logs an error message with class name and colour coding.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    LoadManager.prototype.logE = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        LogUtils.logError.apply(LogUtils, __spreadArrays([pText, { className: "LoadManager", color: "orange" }], pParams));
    };
    return LoadManager;
}(PIXI.Container));
exports.LoadManager = LoadManager;
//# sourceMappingURL=LoadManager.js.map